import { makeActionCreator } from '../../config/store/utils'
import { searchProviderWithType } from '../../services/search'

export const SEARCH_BUYERS = 'SEARCH_BUYERS'
export const SEARCH_BUYERS_ERROR = 'SEARCH_BUYERS_ERROR'
export const SEARCH_BUYERS_SUCCESS = 'SEARCH_BUYERS_SUCCESS'
export const onSearchBuyers = makeActionCreator(SEARCH_BUYERS)
export const onSearchBuyersError = makeActionCreator(SEARCH_BUYERS_ERROR, 'payload')
export const onSearchBuyersSuccess = makeActionCreator(SEARCH_BUYERS_SUCCESS, 'payload')
export const onSearchBuyersThunk = (term, type) => async dispatch => {
  dispatch(onSearchBuyers())

  try {
    const response = await searchProviderWithType({ text: term, idType: type })
    if (response.status !== 200) {
      return dispatch(onSearchBuyersError(response.data.errores))
    }

    const options = response.data.map(result => ({
      cat: result.sector,
      name: result.name,
      value: type === 2 ? result.entcode : result.rut
    }))

    return dispatch(onSearchBuyersSuccess({ options }))
  } catch (error) {
    return dispatch(onSearchBuyersError({ error }))
  }
}
